import '../style/faq.css'
function Faq(){
    return(
        <div className="FaqMainContainer">
            <div className='FaqMainDiv'>
            <h1>FAQ</h1>
            </div>
            
        </div>
    )
}
export default Faq;
